// Tenant branding configuration types
export interface TenantBranding {
  tenant_id: string;
  /** Display name for the sign-in pages (the public branding API). */
  name?: string;
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  custom_css: string | null;
  custom_domain: string | null;
  privacy_policy_url?: string | null;
  terms_of_use_url?: string | null;
}

export interface TenantContext {
  tenant_id: string;
  name: string;
  status: 'active' | 'suspended' | 'deleted';
  branding: TenantBranding;
  enabled_components: string[];
}

// QDS defaults: --qds-brand-sky (#38bdf8) / --qds-bg (#0f172a).
// `qaim` is the platform-operator tenant and the default tenant
// (docs/ADMIN-CONSOLES-SPEC.md §1).
export const DEFAULT_BRANDING: TenantBranding = {
  tenant_id: 'qaim',
  name: 'QAIM',
  logo_url: null,
  primary_color: '#38bdf8',
  secondary_color: '#0f172a',
  custom_css: null,
  custom_domain: null,
};

// Fallback tenant context when the control plane is unreachable or has no
// record for the tenant. Auth flows must keep working in that case: the
// login page probes Kratos availability itself, so listing a component here
// only permits the probe — it does not assert the service is up.
export const DEFAULT_TENANT_CONTEXT: TenantContext = {
  tenant_id: 'qaim',
  name: 'QAIM Platform',
  status: 'active',
  branding: DEFAULT_BRANDING,
  enabled_components: ['hydra', 'kratos', 'keto', 'oathkeeper'],
};
